import { render, staticRenderFns } from "./HkiaraceHomePageSetting.vue?vue&type=template&id=85c4f0c8&scoped=true"
import script from "./HkiaraceHomePageSetting.vue?vue&type=script&lang=js"
export * from "./HkiaraceHomePageSetting.vue?vue&type=script&lang=js"
import style0 from "./HkiaraceHomePageSetting.vue?vue&type=style&index=0&id=85c4f0c8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c4f0c8",
  null
  
)

export default component.exports